import DOMPurify from "dompurify";

export default function RichHTML({ html, className = "" }) {
  if (!html) return null;
  let content = html;
  if (!/<[a-z][\s\S]*>/i.test(html)) content = html.replace(/\n/g, "<br/>");
  const clean = DOMPurify.sanitize(content, { USE_PROFILES: { html: true } });
  return <div className={"mf-rich " + className} dangerouslySetInnerHTML={{ __html: clean }} />;
}
